import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { NodeSamlState } from './types';
import { RootState } from '../../../types';

export const state: NodeSamlState = {
    detail: undefined,
    acsRedirectData: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeSaml: Module<NodeSamlState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
